import type { Scenario, Subscription } from "@/domain/entities";
import { useLocale } from "../i18n/LocaleProvider";
import { Segmented } from "./Segmented";

interface Props {
  subscriptions: Subscription[];
  scenarios: Scenario[];
  value: string | undefined;
  onChange: (subscriptionId: string) => void;
}

/** Picks the scenario whose calendar or report is shown; the choice is shared by both tabs. */
export function ScenarioSwitch({ subscriptions, scenarios, value, onChange }: Props) {
  const { t, pick } = useLocale();
  if (subscriptions.length < 2) return null;
  const options = subscriptions.map((subscription) => {
    const scenario = scenarios.find((s) => s.id === subscription.scenarioId);
    return { id: subscription.id, label: scenario ? pick(scenario.name) : subscription.scenarioId };
  });
  return <Segmented options={options} value={value} onChange={onChange} ariaLabel={t.settings.scenarios} />;
}
